var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 44C88 68.3005 68.3005 88 44 88C19.6995 88 0 68.3005 0 44C0 19.6995 19.6995 0 44 0C68.3005 0 88 19.6995 88 44ZM6.6 44C6.6 64.6554 23.3445 81.4 44 81.4C64.6554 81.4 81.4 64.6554 81.4 44C81.4 23.3445 64.6554 6.6 44 6.6C23.3445 6.6 6.6 23.3445 6.6 44Z",
    fill: "url(#paint0_linear_1671_24275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7 44C86.5225 44 88.0129 45.4796 87.8763 47.297C87.266 55.4198 84.41 63.2377 79.5967 69.8625C74.7835 76.4874 68.2308 81.6195 60.6942 84.71C59.0079 85.4015 57.1402 84.4413 56.577 82.708C56.0138 80.9747 56.9699 79.1264 58.6468 78.4127C64.8609 75.7679 70.2635 71.48 74.2572 65.9832C78.251 60.4863 80.6594 54.0231 81.2545 47.2959C81.4151 45.4804 82.8775 44 84.7 44Z",
    fill: "#C90000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1671_24275",
    x1: 0.598053,
    y1: 0,
    x2: 0.598053,
    y2: 86.8039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A5A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlaImage);
export default __webpack_public_path__ + "static/media/sla-image.0c8c6f70.svg";
export { ForwardRef as ReactComponent };